<div class="row">
  <div class="col-md-12 col-xs-12 ">
    <app-expense-list></app-expense-list>
  </div>
  <!-- <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <p class="h4">gastos</p>
      </div>
      <div class="card-body">
        <form
          action=""
          [formGroup]="expenseForm"
          (ngSubmit)="registerExpense()"
          class="form-horizontal form-material"
          id="expenseform"
          novalidate
        >
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="expenseForm.controls['monto']"
                [controlName]="'Monto'"
              >
                <label for="monto">Monto</label>
                <input
                  class="form-control"
                  type="number"
                  id="monto"
                  formControlName="monto"
                  placeholder="monto"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="expenseForm.controls['descripcion']"
                [controlName]="'Descripción'"
              >
                <label for="descripcion">Descripción</label>
                <input
                  class="form-control"
                  type="text"
                  id="descripcion"
                  formControlName="descripcion"
                  placeholder="descripción"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="expenseForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Agregar'"
                ></app-button-loader>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>-->

  <!-- <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <p class="h4">Lista de Gastos</p>
      </div>
      <div class="card-body">
        <table class="table table-bordered table-hover table-sm table-md">
          <thead>
            <tr>
              <th>#</th>
              <th>Nombre Usuario</th>
              <th>Montos</th>
              <th>Descripcion</th>
              <th>Fecha de Registro</th>

              <th>Accion</th>
            </tr>
          </thead>
          <tbody *ngFor="let expense of expenses; let i = index">
            <tr>
              <th scope="row">{{ i + 1 }}</th>
              <td>{{ expense.nombre_usuario }}</td>
              <td>{{ expense.monto }}</td>
              <td>{{ expense.descripcion }}</td>
              <td>{{ expenses.fecha }}</td>
              &lt;!&ndash; <td>
              <label
                class="switch switch_type1"
                role="switch"
                *ngIf="product.habilitado == true"
              >
                <input
                  type="checkbox"
                  class="switch__toggle"
                  (click)="enableUser(product.id)"
                  checked="false"
                />
                <span class="switch__label"></span>
              </label>
              <label
                class="switch switch_type1"
                role="switch"
                *ngIf="product.habilitado == false"
              >
                <input
                  type="checkbox"
                  class="switch__toggle"
                  (click)="enableUser(product.id)"
                />
                <span class="switch__label"></span>
              </label>
            </td>&ndash;&gt;
              <td>
                <button type="button" class="btn btn-default btn-lg">
                  <i class="fa fa-pencil-square-o"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>-->
</div>
